import { z } from 'zod';

import {
  EntityBaseSchema,
  EntityMetadataSchema,
  LanguageCodeSchema,
  PositiveNumberSchema,
  RegexStringSchema,
  StringSchema,
} from '../../base';

export const PronunciationRegexSchema = RegexStringSchema.describe(
  'Valid regex pattern to match in TTS output text before it is spoken',
);

export const PronunciationReplacementSchema = StringSchema.describe(
  'Text to replace the regex match with before TTS speaks',
);

export const PronunciationCaseSensitiveSchema = z
  .boolean()
  .describe('Whether the regex match is case sensitive');

export const PronunciationLanguageCodeSchema = LanguageCodeSchema.or(
  z.literal(''),
).describe(
  'BCP 47 Language code to scope this rule to, or empty for all languages',
);

export const PronunciationDescriptionSchema = StringSchema;

export const PronunciationPositionSchema = PositiveNumberSchema;

export const PronunciationNameSchema = StringSchema;

export const PronunciationEntitySchema = EntityBaseSchema.extend({
  regex: PronunciationRegexSchema,
  replacement: PronunciationReplacementSchema,
  caseSensitive: PronunciationCaseSensitiveSchema,
  languageCode: PronunciationLanguageCodeSchema,
  description: PronunciationDescriptionSchema,
  position: PronunciationPositionSchema,
  name: PronunciationNameSchema,
});

export const PronunciationSchema =
  PronunciationEntitySchema.merge(EntityMetadataSchema);

export type Pronunciation = z.infer<typeof PronunciationSchema>;
